var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svgWidth",
    width: 432,
    height: 256,
    viewBox: "0 0 432 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55329 176.928C-9.04996 114.608 97.707 36.2681 230.84 13.6164C521.377 -34.3744 333.992 64.1434 397.625 104.803C483.029 138.774 394.943 226.101 261.811 248.753C128.678 271.405 12.1565 239.247 1.55329 176.928Z",
    fill: "#A3CCFE",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain1);
export default __webpack_public_path__ + "static/media/main1.2767b908451de02692e8a31ba484274d.svg";
export { ForwardRef as ReactComponent };